import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import {deleteActiveGenderSort, setActiveGenderSort} from "../../helpers/product";
import { isMobileOnly} from "react-device-detect";
import qs from "query-string";
import {useTranslation} from "react-i18next";

const ShopCarbonPlate = ({ location, currentQuery, setCurrentQuery, carbonPlates, getSortParams, isHome , setLoadingProducts }) => {
  const [isSmallScreen, setSmallScreen] = useState(false);
    const { t } = useTranslation()

  const query = qs.parse(location.search, {
      ignoreQueryPrefix: true
  });
  const filterButtons = document.querySelectorAll(
      ".sidebar-widget-tag-carbon-plate button"
  );

    filterButtons.forEach(item => {
        item.classList.remove("active");
    });

    if (query && query.carbonPlate) {
        let carbonPlates = query.carbonPlate.split('_');
        carbonPlates.map(size => {
            var element = document.getElementById("carbonPlate"+size);
            if (element){
                element.classList.add("active")
            }
        })
    }

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(false)
        }
    })

    function constructAddQueryPath(query, size) {
        if (query && query.carbonPlates) {
            return query.carbonPlates + "_" + size
        }
        return size
    }

  return (
    <div className="sidebar-widget mt-10">
        {
            isMobileOnly || isSmallScreen ?
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Avec plaque carbone ?" : "Plaque carbone :"}</h4>
                    <div className="sidebar-widget-tag-carbon-plate mt-10" style={{display: 'block'}}>
                        {carbonPlates ? (
                            <ul>
                                {carbonPlates.map((carbonPlate, key) => {
                                    return (
                                        <li key={"carbonPlate"+key}>
                                            <button
                                                className="toto"
                                                id={"carbonPlate"+carbonPlate}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("carbonPlate", "");
                                                        setCurrentQuery({ ...currentQuery, carbonPlate: ""});
                                                        deleteActiveGenderSort(e);
                                                    } else {
                                                        getSortParams("carbonPlate", carbonPlate);
                                                        setCurrentQuery({ ...currentQuery, carbonPlate: carbonPlate});
                                                        setActiveGenderSort(e);
                                                    }
                                                }}
                                            >
                                                {t(carbonPlate.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
                :
                <div>
                    <h4 className="pro-sidebar-title">{isHome ? "Avec plaque carbone ?" : "Plaque carbone :"}</h4>
                    <div className="sidebar-widget-tag-carbon-plate mt-10">
                        {carbonPlates ? (
                            <ul>
                                {carbonPlates.map((carbonPlate, key) => {
                                    return (
                                        <li key={"carbonPlate"+key}>
                                            <button
                                                className="toto"
                                                id={"carbonPlate"+carbonPlate}
                                                onClick={e => {
                                                    setLoadingProducts(true)
                                                    if (e.currentTarget.classList.contains('active')) {
                                                        getSortParams("carbonPlate", "");
                                                        setCurrentQuery({ ...currentQuery, carbonPlate: ""});
                                                        deleteActiveGenderSort(e);
                                                    } else {
                                                        getSortParams("carbonPlate", carbonPlate);
                                                        setCurrentQuery({ ...currentQuery, carbonPlate: carbonPlate});
                                                        setActiveGenderSort(e);
                                                    }
                                                }}
                                            >
                                                {t(carbonPlate.toLowerCase())}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        ) : (
                            "No tags found"
                        )}
                    </div>
                </div>
        }
    </div>
  );
};

export function getLabel(carbonPlate, t){
    switch (carbonPlate){
        case "Women":
            return t('carbonPlate')
        case "Men":
            return "Homme"
        case "Unisex":
            return "Non Genré"
        default:
            return
    }
}

export function ConstructRemoveGenderQueryPath(query, sizeToRemove) {
    if (query && query.carbonPlates) {
        let carbonPlates = query.carbonPlates.split('_');
        carbonPlates = carbonPlates.filter(size => {
            return size !== sizeToRemove;
        })
        if (carbonPlates.length > 0) {
            let newSizeQuery = ""
            carbonPlates.map((size, index) => {
                if (index == 0){
                    newSizeQuery += size
                } else {
                    newSizeQuery +=  "_" + size
                }
            })
            return newSizeQuery
        } else {
            return null
        }

    }
    return null
}

ShopCarbonPlate.propTypes = {
  getSortParams: PropTypes.func,
  tags: PropTypes.array,
  currentQuery: PropTypes.object,
  setCurrentQuery: PropTypes.func,
    location: PropTypes.string
};

export default ShopCarbonPlate;
